import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { appRoutes } from './app.routes';
import { crmAuthInterceptor } from './auth/crm-auth.interceptor';
import { crmAuthErrorInterceptor } from './auth/crm-auth-error.interceptor';
import { requestDedupInterceptor } from './request-dedup.interceptor';
import { apiToastInterceptor } from '../../../../libs/core/service/api-toast.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withFetch(),
      withInterceptors([crmAuthInterceptor, crmAuthErrorInterceptor, requestDedupInterceptor, apiToastInterceptor]),
    ),
    provideRouter(appRoutes)
  ],
};